<template>
  <div class="masonry-layout">
    <ul v-for="column in numberOfColumns" :key="column" class="images">
      <transition-group
        v-for="image in images[column - 1]"
        :key="image.id"
        :tabindex="column"
        name="fade"
        class="images__item"
        tag="li"
        appear
      >
        <ImageUploadUnsplashImagesSelect
          :key="image.id"
          :image="image"
          :selected-image-id="selectedImage?.id"
          :is-loading-images="isLoadingImages"
          :current-page="currentPage"
          @click="selectImage(image)"
          @dblclick="submitImage(image)"
        />
      </transition-group>
    </ul>
  </div>
</template>

<script>
import ImageUploadUnsplashImagesSelect from '@/components/generics/imageUpload/ImageUploadUnsplashImagesSelect'
export default {
  components: {
    ImageUploadUnsplashImagesSelect,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    numberOfColumns: {
      type: Number,
      required: true,
    },
    isLoadingImages: {
      type: Boolean,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    selectedImage: {
      type: Object,
      required: true,
    },
  },
  emits: ['onSelectImage', 'onSubmitImage'],
  methods: {
    selectImage(image) {
      this.$emit('onSelectImage', image)
    },
    submitImage(image) {
      this.$emit('onSubmitImage', image)
    },
  },
}
</script>

<style lang="scss" scoped>
$list-gutter: $spacing-5xs;

.masonry-layout {
  display: flex;
  align-items: flex-start;
  gap: $list-gutter;

  @media screen and (max-width: $mobile-width-max) {
    flex-wrap: wrap;
  }
}

.images {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: $list-gutter;
  width: 100%;

  &__item {
    border-radius: $spacing-3xs;
    width: 100%;
    height: 100%;
  }
}
</style>
